import { Box, Button, Image, Text } from '@mantine/core';
import plusImage from '../../assets/images/plus-image.png';

const GenerateNewContentButton = ({ title, onClick }) => {
  return (
    <Box display="inline-block">
      <Button size="sm" className="btn-plus-image" onClick={onClick}>
        <Image alt="new" src={plusImage} width={16} height="16" />
        <Text>{title}</Text>
      </Button>
    </Box>
  );
};

export default GenerateNewContentButton;
